const locale = "fr-FR";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "DD/MM/YYYY",
	dateTimeFormat: "DD/MM/YYYY HH:mm",
	"serviceReports.headline": "Rapports de service",
	"serviceReports.sublineMachine": "Consultez et téléchargez les rapports de service de votre machine.",
	"serviceReports.technicianName": "Nom du technicien",
	"serviceReports.machineNameAndNumber": "Machine et numéro de la machine",
	"serviceReports.startDate": "De",
	"serviceReports.endDate": "A",
	"serviceReports.creationDate": "Date de création",
	"serviceReports.openReport": "Ouvrir le rapport de service (PDF)",
	"serviceReports.filter": "Filtre",
	"serviceReports.missionNumber": "Numéro de mission",
	"serviceReports.assignmentType": "Type de rapport de service",
	"serviceReports.reportTypes.IA": "Rapport de démontage/conversion",
	"serviceReports.reportTypes.AC": "Rapport de conseils en matière d'application",
	"serviceReports.reportTypes.IV": "Rapport de préparation d'installation",
	"serviceReports.reportTypes.BA": "Rapport d'inventaire",
	"serviceReports.reportTypes.UV": "Rapport de contrôle de sécurité",
	"serviceReports.reportTypes.IG": "Rapport de montage de machine d'occasion",
	"serviceReports.reportTypes.UB": "Rapport de mesures de qualité",
	"serviceReports.reportTypes.PN": "Rapport de suivi de production",
	"serviceReports.reportTypes.NR": "Rapport d'extension de fonction",
	"serviceReports.reportTypes.IB": "Rapport d'installation / de démarrage",
	"serviceReports.reportTypes.II": "Rapport d'intégration d'installation",
	"serviceReports.reportTypes.IC": "Rapport de réparation interne",
	"serviceReports.reportTypes.MB": "Rapport de gestion de salon",
	"serviceReports.reportTypes.HW": "Rapport de ressources",
	"serviceReports.reportTypes.TT": "Rapport de formation de technicien",
	"serviceReports.reportTypes.SK": "Rapport de formation de client",
	"serviceReports.reportTypes.RP": "Rapport de réparation",
	"serviceReports.reportTypes.RW": "Rapport de réparation et de maintenance",
	"serviceReports.reportTypes.WA": "Rapport de maintenance",
	"serviceReports.reportTypesPlural.IA": "Rapports de démontage/conversion",
	"serviceReports.reportTypesPlural.AC": "Rapports de conseils en matière d'application",
	"serviceReports.reportTypesPlural.IV": "Rapports de préparation d'installation",
	"serviceReports.reportTypesPlural.BA": "Rapports d'inventaire",
	"serviceReports.reportTypesPlural.UV": "Rapports de contrôle de sécurité",
	"serviceReports.reportTypesPlural.IG": "Rapports de montage de machine d'occasion",
	"serviceReports.reportTypesPlural.UB": "Rapports de mesures de qualité",
	"serviceReports.reportTypesPlural.PN": "Rapports de suivi de production",
	"serviceReports.reportTypesPlural.NR": "Rapports d'extension de fonction",
	"serviceReports.reportTypesPlural.IB": "Rapports d'installation / de démarrage",
	"serviceReports.reportTypesPlural.II": "Rapports d'intégration d'installation",
	"serviceReports.reportTypesPlural.IC": "Rapports de réparation interne",
	"serviceReports.reportTypesPlural.MB": "Rapports de gestion de salon",
	"serviceReports.reportTypesPlural.HW": "Rapports de ressources",
	"serviceReports.reportTypesPlural.TT": "Rapports de formation de technicien",
	"serviceReports.reportTypesPlural.SK": "Rapports de formation de client",
	"serviceReports.reportTypesPlural.RP": "Rapports de réparation",
	"serviceReports.reportTypesPlural.RW": "Rapports de réparation et de maintenance",
	"serviceReports.reportTypesPlural.WA": "Rapports de maintenance",
	"serviceReports.loadMore": "Charger plus",
	"serviceReports.loadError": "Une erreur s'est produite dans le chargement des données",
	"serviceReports.noReportsFound": "Aucun rapport de service n'est disponible actuellement.",
	"serviceReports.noReportsAvailable": "Aucun rapport de service n'est disponible actuellement.",
	missingAuthorization: "Autorisation manquante",
	"headline.createCase": "Créer une nouvelle requête de service",
	"headline.caseDetails": "Détails de la requête",
	"headline.contactData": "Données de contact",
	"field.reason.label": "Motif du message",
	"field.machine.label": "Machine et numéro de la machine",
	"field.softwareProblemClassification.label": "Classification du problème",
	"field.softwareInstallationProblem.label": "Problème d'installation",
	"field.softwareLicenseIssue.label": "Problème de licence",
	"field.softwareType.label": "Type de logiciel",
	"field.softwareModule.label": "Module logiciel",
	"field.errorNumber.label": "Numéros d'erreur",
	"field.errorNumber.explanation": "p. ex. 0000FC00, 1.10.58102409 ou 6000",
	"field.errorNumber.addAnotherNumber": "Ajouter d'autres numéros d'erreur",
	"field.errorNumber.errorMessage": "Numéro d'erreur non valide",
	"field.message.label": "Message",
	"field.message.placeholder": "Veuillez décrire (sans formule de salutation) votre préoccupation/problème de façon aussi concrète que possible et aussi détaillée que nécessaire. Merci.",
	"field.fileUpload.label": "Annexes",
	"field.fileUpload.info": "Formats de fichier autorisés : IMG, JPG, PNG, PDF, HTML, fichiers TruTops etc. (max. 16 Mo) et fichiers vidéos MP4 (max. 50 Mo)",
	"field.salutation.label": "Formulaire d''adresse",
	"field.salutation.male": "Monsieur",
	"field.salutation.female": "Madame",
	"field.firstName.label": "Prénom",
	"field.lastName.label": "Nom",
	"field.email.label": "E-mail",
	"field.phone.label": "Numéro de téléphone",
	"button.submit": "Envoyer",
	"button.cancel": "Annuler",
	"button.back": "Retour",
	"button.next": "Suivant",
	"button.close": "Fermer",
	"button.ok": "Ok",
	"auth.error": "Une erreur inattendue est survenue.",
	"select.placeholder": "Veuillez sélectionner...",
	"validation.requiredField": "Ce champ est obligatoire",
	"validation.invalidEmail": "Veuillez indiquer une adresse e-mail valide",
	"validation.maxAllowedCharacters": "Nombre maximal de caractères autorisés : {{number}}",
	"validation.requiredFieldsExplanation": "Les champs obligatoires sont marqués d''une *.",
	"validation.invalidPhoneNumber": "Veuillez saisir un numéro de téléphone valide.",
	"softwareProblemClassification.standstill": "Arrêt",
	"softwareProblemClassification.fault": "Dysfonctionnement",
	"softwareProblemClassification.slightImpairment": "Légère déficience",
	"softwareProblemClassification.generalInquiry": "Demande d'ordre général",
	"serviceCase.proactiveCaseClosure.title": "Retour & demande de fermeture de requête",
	"serviceCase.proactiveCaseClosure.instructions": "Afin de demander la fermeture de requête et nous aider à améliorer notre Predictive Service, nous vous prions de bien vouloir nous faire un retour.",
	"serviceCase.proactiveCaseClosure.question.submit": "Envoyer",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Fermeture de requête demandée Merci pour votre retour.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "Ok",
	"serviceCase.proactiveCaseClosure.question.anomaly": "L'anomalie signalée était-elle présente sur votre machine ?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Un guide technique a-t-il été mis à disposition ?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "Avez-vous pu solutionner le problème vous-même à l'aide du ou des guides techniques ?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "Souhaitez-vous mettre en pause les notifications pour ce genre d'anomalie ?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "Pendant combien de temps souhaitez-vous mettre en pause les notifications pour ce genre d'anomalie ?",
	"serviceCase.proactiveCaseClosure.question.comment": "Veuillez expliquer la raison pour laquelle vous souhaitez mettre en pause les notifications pour ce genre d'anomalie :",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "Commentaire obligatoire pour demander la fermeture de la requête et envoyer le retour",
	"serviceCase.proactiveCaseClosure.answers.yes": "Oui",
	"serviceCase.proactiveCaseClosure.answers.no": "Non",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 jours",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 jours",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 jours",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 jours",
	"sisConnector.success.headline": "Le cas de service a bien été créé.",
	"sisConnector.success.orderNumberRequired.title": "Remarque :",
	"sisConnector.success.orderNumberRequired.text": "Veuillez ajouter sur la page des détails du cas un numéro de commande pour la facturation du cas et d'autres services.",
	"sisConnector.success.technicalGuide.title": "Un guide technique est disponible pour ce(s) numéro(s) d'erreur.",
	"sisConnector.success.technicalGuide.text": "Un ou plusieurs guides techniques ont pu être trouvés grâce au(x) numéro(s) d'erreur saisi(s). Dans env. 50 % des cas, vous êtes désormais en mesure de résoudre le problème par vous-même. Cette fonction est uniquement disponible avec un contrat de service correspondant.",
	"sisConnector.success.outsideOfServiceHours": "Veuillez noter que les cas créés en dehors de nos heures de service ne seront pas traités.",
	"sisConnector.success.serviceTimes.MonFri": "Nos heures de service sont : du lundi au vendredi",
	"sisConnector.success.serviceTimes.Sat": "et le samedi",
	"sisConnector.success.withTechnicalServiceHotline": "Si vous avez besoin d'une assistance immédiate, veuillez appeler le service technique de TRUMPF ({{hotline}}).",
	"sisConnector.success.withoutTechnicalServiceHotline": "Si vous avez besoin d'une assistance immédiate, veuillez appeler le service technique de TRUMPF.",
	"sisConnector.success.caseId": "Numéro de la demande",
	"sisConnector.failed.headline": "La requête de service n'a pas pu être créée.",
	"sisConnector.failed.unknownError": "Veuillez réessayer ou adressez-vous à votre service d'assistance."
};
var frFR = {
	locale: locale,
	translations: translations
};

export { frFR as default, locale, translations };
//# sourceMappingURL=fr-FR-D2Y-WQKW.js.map

//# sourceMappingURL=fr-FR-D2Y-WQKW.js.map